import { createFileRoute } from "@tanstack/react-router";
import Videography from "@/pages/Videography";
import { seoHead } from "@/lib/seo";
import { industriesQuery, projectsLeanQuery, safePrefetch } from "@/lib/publicQueries";

export const Route = createFileRoute("/film")({
  loader: async ({ context }) => {
    await Promise.all([
      safePrefetch(context.queryClient, projectsLeanQuery({ publicOnly: true })),
      safePrefetch(context.queryClient, industriesQuery()),
    ]);
  },
  head: () =>
    seoHead({
      title: "Videoproduktion Mannheim: Imagefilm, Recruiting | Clicks DMP",
      description:
        "Imagefilme, Recruiting-Videos, Event- und Immobilienfilme aus Mannheim. Drehtag vor Ort, fertiger Film innerhalb einer Woche, Drohne mit EU-Kompetenznachweis.",
      path: "/film",
    }),
  component: Videography,
});
